/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------


==========================================================================================*/
import {BULK_RESIZE_IMAGES} from '@/graphql'
import apollo from './apollo'

const actions = {
  setStudent ({ commit }, payload) {
    commit('setStudent', payload)
  },
  setDeletedUser ({ commit }, payload) {
    commit('setDeletedUser', payload)
  },
  setRegisterUserEmail ({ commit }, payload) {
    commit('setRegisterUserEmail', payload)
  },
  setNewsletterJson ({ commit }, payload) {
    commit('setNewsletterJson', payload)
  },
  setBuilderMenu ({ commit }, payload) {
    commit('setBuilderMenu', payload)
  },
  setCompleteImg ({ commit }, payload) {
    commit('setCompleteImg', payload)
  },
  setResizeImgs ({ commit }, { payload, notify }) {
    function sendResizeImage (imgs, width) {
      const elements = imgs.splice(0, 5)
      commit('setStartImg', elements)
      apollo.mutate({
        mutation: BULK_RESIZE_IMAGES,
        variables: {
          id: elements,
          width
        }
      })
        .then(response => {
          if (response.data.bulkResizeImges.status === 'Success') {
            commit('setCompleteImg', elements)
            if (imgs.length > 0) {
              sendResizeImage(imgs, width)
            } else {
              notify({
                title: 'Images',
                text: 'Resized successfully!',
                color: 'success',
                position: 'top-right',
                time: 8000,
                icon: 'close'
              })
            }
          }
        })
    }
    sendResizeImage(payload.imgs, payload.width)
  },
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },
  updateAppTitle ({ commit }, val) {
    commit('UPDATE_APP_TITLE', val)
  },
  UpdateAppLogo ({ commit }, imgSrc) {
    commit('UPDATE_APP_LOGO', imgSrc)
  },
  updateAppLoginShowImg ({ commit }, val) {
    commit('UPDATE_APP_SHOW_LOGIN_IMG', val)
  },
  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  updateTopbarMessageCounter ({ commit }, payload) {
    commit('UPDATE_APP_TOPBAR_MESSAGE_COUNTER', payload)
  },
  updateAppCurrentLocation ({ commit }, payload) {
    commit('UPDATE_APP_CURRENT_LOCATION', payload)
  },

  updateTeacherMessageCount ({ commit }, payload) {
    commit('UPDATE_TEACHER_MESSAGE_COUNT', payload)
  },
  updateAppCurrentLocationDropdown ({ commit }, payload) {
    commit('UPDATE_APP_CURRENT_LOCATION_DROPDOWN', payload)
  },
  updateAppActivityProgramDropdown ({ commit }, payload) {
    commit('UPDATE_APP_ACTIVITY_PROGRAM_DROPDOWN', payload)
  },
  updateAppActivityProgramStudentDropdown ({ commit }, payload) {
    commit('UPDATE_APP_ACTIVITY_PROGRAM_STUDENT_DROPDOWN', payload)
  },
  updateAppActivityRoom ({ commit }, payload) {
    commit('UPDATE_APP_CURRENT_ACTIVITY_ROOM', payload)
  },
  updateStudentAccountDetails ({ commit }, payload) {
    commit('UPDATE_STUDENT_ACCOUNT_DETAILS', payload)
  },
  updateCurrentLocationPendingUser ({ commit }, payload) {
    commit('UPDATE_CURRENT_LOCATION_PENDING_USER', payload)
  },
  updateCurrentLocationStaticCard ({ commit }, payload) {
    commit('UPDATE_CURRENT_LOCATION_STATIC_CARD', payload)
  },
  updateAgencyAccountDetails ({ commit }, payload) {
    commit('UPDATE_AGENCY_ACCOUNT_DETAILS', payload)
  },
  updateAgencyStudents ({ commit }, payload) {
    commit('UPDATE_AGENCY_STUDENTS', payload)
  },
  updateSetupFormSteps ({ commit }, payload) {
    commit('UPDATE_SETUP_FORM_STEPS', payload)
  }

}

export default actions
